import { render, staticRenderFns } from "./VenueOnboardingPage.vue?vue&type=template&id=29db9c44"
import script from "./VenueOnboardingPage.vue?vue&type=script&lang=ts"
export * from "./VenueOnboardingPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports